/**
 * De vaste set kleuren waaruit een organisatie kiest — voor labels op een
 * huishouden én voor de statuskleur in de agenda. De sleutel is een CSS-klasse
 * (`label-chip--<kleur>`, `status-dot--<kleur>`), geen hexcode in de gegevens:
 * dan blijft de huisstijl op één plek staan.
 *
 * AI-CONTEXT: See docs/patterns.md#ui-color-tokens
 * AI-CONTEXT: See docs/features/planner-overzicht-bkb.md
 */

/** @type {Array<string>} */
const PALETTE_COLORS = ['coral', 'teal', 'dark', 'amber', 'green', 'purple', 'grey']

/** De kleurnamen zoals de gebruiker ze leest. @type {Record<string, string>} */
const COLOR_NAMES = {
    coral: 'Koraal',
    teal: 'Turkoois',
    dark: 'Donker',
    amber: 'Amber',
    green: 'Groen',
    purple: 'Paars',
    grey: 'Grijs',
}

/**
 * @param {*} value
 * @returns {boolean}
 */
const isPaletteColor = (value) => PALETTE_COLORS.includes(value)

export { PALETTE_COLORS, COLOR_NAMES, isPaletteColor }
